import {useEffect, useState} from 'react';
import {Storage} from 'utils/utils';

export const useLocalSessionId = (formDataHash: string) => {
    const [sessionId, setSessionId] = useState(Storage.getItem(formDataHash) || '');

    useEffect(() => {
        if (sessionId) {
            Storage.setItem(formDataHash, sessionId);
        } else {
            Storage.removeItem(formDataHash);
        }
    }, [formDataHash, sessionId]);

    return {
        sessionId,
        setSessionId,
    };
};
